import PromptSuggestionRecord from "models/view-models/conversations/prompt-suggestions/prompt-suggestion-record";
import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import ChatPromptSuggestionButton from "molecules/chat-prompt-suggestion-button/chat-prompt-suggestion-button";
import React from "react";
import { CollectionUtils } from "utilities/collection-utils";
import { t } from "utilities/localization-utils";
import Button from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { ButtonStyles } from "atoms/constants/button-styles";
const CSS_CLASS_NAME = "c-chat-prompt-suggestions";
export interface ChatPromptSuggestionsProps {
    promptSuggestions: PromptSuggestionRecord[];
    onClick: (prompt: PromptSuggestionRecord) => void;
    onDismiss: () => void;
}
const ChatPromptSuggestions = ({
    promptSuggestions,
    onClick,
    onDismiss,
}: ChatPromptSuggestionsProps) => {
    const handleClick = (prompt: PromptSuggestionRecord) => {
        onClick(prompt);
        onDismiss();
    };

    return (
        <>
            {CollectionUtils.hasValues(promptSuggestions) && (
                <section
                    className={CSS_CLASS_NAME}
                    data-test-id="chat-prompt-suggestions__section">
                    <Heading
                        priority={HeadingPriority.Three}
                        cssClassName={`${CSS_CLASS_NAME}__heading`}>
                        {t("chat-prompt-suggestions--heading")}

                        <Button
                            style={ButtonStyles.None}
                            cssClassName={`${CSS_CLASS_NAME}__close-button`}
                            onClick={onDismiss}>
                            <Icon type={Icons.Close} />
                            <span className="sr-only">{t("close")}</span>
                        </Button>
                    </Heading>
                    <ul
                        className={`${CSS_CLASS_NAME}__list`}
                        data-test-id="chat-prompt-suggestions__list">
                        {promptSuggestions.map((prompt) => (
                            <li
                                key={prompt.id}
                                className={`${CSS_CLASS_NAME}__list-item`}>
                                <ChatPromptSuggestionButton
                                    onClick={handleClick}
                                    prompt={prompt}
                                />
                            </li>
                        ))}
                    </ul>
                </section>
            )}
        </>
    );
};

export default ChatPromptSuggestions;
